(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maison-password"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.maison-pw');
    roots.forEach(function (root) {
      function setScreen(name) {
        root.setAttribute('data-screen', name);
      }
      root.querySelectorAll('[data-goto]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          setScreen(el.getAttribute('data-goto'));
        });
      });

      var klaviyoKey = root.getAttribute('data-klaviyo-key');
      var klaviyoList = root.getAttribute('data-klaviyo-list');
      var successMsg = root.getAttribute('data-success') || 'Thank you!';
      var form = root.querySelector('.maison-pw__signup-form');

      function showSuccess() {
        if (!form) return;
        form.innerHTML = '<p class="maison-pw__success" role="status"></p>';
        form.querySelector('.maison-pw__success').textContent = successMsg;
      }

      if (form && klaviyoKey && klaviyoList) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var input = form.querySelector('input[type="email"]');
          var email = input ? input.value.trim() : '';
          if (!email) return;
          var btn = form.querySelector('.maison-pw__button');
          if (btn) btn.setAttribute('disabled', 'disabled');
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoKey), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Password page',
                  profile: { data: { type: 'profile', attributes: { email: email } } }
                },
                relationships: { list: { data: { type: 'list', id: klaviyoList } } }
              }
            })
          })
            .then(function () { showSuccess(); })
            .catch(function () {
              if (btn) btn.removeAttribute('disabled');
            });
        });
      }

      var cd = root.querySelector('.maison-pw__countdown');
      if (cd) {
        var raw = (cd.getAttribute('data-countdown') || '').trim();
        var target = new Date(raw.replace(' ', 'T')).getTime();
        var els = {
          days: cd.querySelector('[data-cd="days"]'),
          hours: cd.querySelector('[data-cd="hours"]'),
          minutes: cd.querySelector('[data-cd="minutes"]'),
          seconds: cd.querySelector('[data-cd="seconds"]')
        };
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var tick = function () {
          var diff = target - Date.now();
          if (isNaN(target) || diff <= 0) {
            els.days.textContent = '00';
            els.hours.textContent = '00';
            els.minutes.textContent = '00';
            els.seconds.textContent = '00';
            return false;
          }
          var s = Math.floor(diff / 1000);
          els.days.textContent = pad(Math.floor(s / 86400));
          els.hours.textContent = pad(Math.floor((s % 86400) / 3600));
          els.minutes.textContent = pad(Math.floor((s % 3600) / 60));
          els.seconds.textContent = pad(s % 60);
          return true;
        };
        if (tick()) {
          var timer = setInterval(function () {
            if (!tick()) clearInterval(timer);
          }, 1000);
        }
      }

      var params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') === 'true' || root.querySelector('.maison-pw__success')) {
        setScreen('signup');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
